export const ALL_USER_TEAM_AUDIOS_REQUEST =
  "API/ENTITIES/ALL_USER_TEAM_AUDIOS_REQUEST";
export const ALL_USER_TEAM_AUDIOS_REQUEST_FAILURE =
  "API/ENTITIES/ALL_USER_TEAM_AUDIOS_REQUEST_FAILURE";
export const ALL_USER_TEAM_AUDIOS_REQUEST_SUCCESS =
  "API/ENTITIES/ALL_USER_TEAM_AUDIOS_REQUEST_SUCCESS";

export const USER_TEAM_AUDIOS_REQUEST = "API/ENTITIES/USER_TEAM_AUDIOS_REQUEST";
export const USER_TEAM_AUDIOS_REQUEST_FAILURE =
  "API/ENTITIES/USER_TEAM_AUDIOS_REQUEST_FAILURE";
export const USER_TEAM_AUDIOS_REQUEST_SUCCESS =
  "API/ENTITIES/USER_TEAM_AUDIOS_REQUEST_SUCCESS";

export const USER_TEAM_AUDIOS_IN_FOLDER_REQUEST =
  "API/ENTITIES/USER_TEAM_AUDIOS_IN_FOLDER_REQUEST";
export const USER_TEAM_AUDIOS_IN_FOLDER_REQUEST_FAILURE =
  "API/ENTITIES/USER_TEAM_AUDIOS_IN_FOLDER_REQUEST_FAILURE";
export const USER_TEAM_AUDIOS_IN_FOLDER_REQUEST_SUCCESS =
  "API/ENTITIES/USER_TEAM_AUDIOS_IN_FOLDER_REQUEST_SUCCESS";

export const USER_TEAM_AUDIOS_SEARCH_REQUEST =
  "API/ENTITIES/USER_TEAM_AUDIOS_SEARCH_REQUEST";
export const USER_TEAM_AUDIOS_SEARCH_REQUEST_FAILURE =
  "API/ENTITIES/USER_TEAM_AUDIOS_SEARCH_REQUEST_FAILURE";
export const USER_TEAM_AUDIOS_SEARCH_REQUEST_SUCCESS =
  "API/ENTITIES/USER_TEAM_AUDIOS_SEARCH_REQUEST_SUCCESS";

export const USER_TEAM_AUDIO_DELETE_REQUEST =
  "API/ENTITIES/USER_TEAM_AUDIO_DELETE_REQUEST";
export const USER_TEAM_AUDIO_DELETE_REQUEST_FAILURE =
  "API/ENTITIES/USER_TEAM_AUDIO_DELETE_REQUEST_FAILURE";
export const USER_TEAM_AUDIO_DELETE_REQUEST_SUCCESS =
  "API/ENTITIES/USER_TEAM_AUDIO_DELETE_REQUEST_SUCCESS";

export const USER_TEAM_AUDIO_UPDATE_REQUEST =
  "API/ENTITIES/USER_TEAM_AUDIO_UPDATE_REQUEST";
export const USER_TEAM_AUDIO_UPDATE_REQUEST_FAILURE =
  "API/ENTITIES/USER_TEAM_AUDIO_UPDATE_REQUEST_FAILURE";
export const USER_TEAM_AUDIO_UPDATE_REQUEST_SUCCESS =
  "API/ENTITIES/USER_TEAM_AUDIO_UPDATE_REQUEST_SUCCESS";

export const USER_TEAM_AUDIO_UPLOAD_REQUEST =
  "API/ENTITIES/USER_TEAM_AUDIO_UPLOAD_REQUEST";
export const USER_TEAM_AUDIO_UPLOAD_REQUEST_FAILURE =
  "API/ENTITIES/USER_TEAM_AUDIO_UPLOAD_REQUEST_FAILURE";
export const USER_TEAM_AUDIO_UPLOAD_REQUEST_SUCCESS =
  "API/ENTITIES/USER_TEAM_AUDIO_UPLOAD_REQUEST_SUCCESS";

export const USER_AUDIO_UPLOAD_URL_REQUEST =
  "API/ENTITIES/USER_AUDIO_UPLOAD_URL_REQUEST";
export const USER_AUDIO_UPLOAD_URL_REQUEST_FAILURE =
  "API/ENTITIES/USER_AUDIO_UPLOAD_URL_REQUEST_FAILURE";
export const USER_AUDIO_UPLOAD_URL_REQUEST_SUCCESS =
  "API/ENTITIES/USER_AUDIO_UPLOAD_URL_REQUEST_SUCCESS";

export const ADD_USER_TEAM_AUDIOS_PLACEHOLDERS =
  "API/ENTITIES/ADD_USER_TEAM_AUDIOS_PLACEHOLDERS";

export const UPDATE_USER_TEAM_AUDIO_PLACEHOLDER_PROGRESS =
  "API/ENTITIES/UPDATE_USER_TEAM_AUDIO_PLACEHOLDER_PROGRESS";

export const CLEAR_USER_TEAM_AUDIO_UPLOAD_ERRORS =
  "API/ENTITIES/CLEAR_USER_TEAM_AUDIO_UPLOAD_ERRORS";

export const USER_TEAM_AUDIOS_CLEAR = "API/ENTITIES/USER_TEAM_AUDIOS_CLEAR";

export const USER_TEAM_AUDIOS_DELETE_REQUEST =
  "API/ENTITIES/USER_TEAM_AUDIOS_DELETE_REQUEST";
export const USER_TEAM_AUDIOS_DELETE_REQUEST_FAILURE =
  "API/ENTITIES/USER_TEAM_AUDIOS_DELETE_REQUEST_FAILURE";
export const USER_TEAM_AUDIOS_DELETE_REQUEST_SUCCESS =
  "API/ENTITIES/USER_TEAM_AUDIOS_DELETE_REQUEST_SUCCESS";
